<template>
  <div class="d-inline-block">
    <div class="btn-group" role="group">
      <button :id="'currency-dropdown' + label_id" type="button" v-bind:class="{ 'text-dark' : ui_style == 'dark', 'text-light' : ui_style == 'light'}" class="p-0 btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="background:none;border:none;" v-html="current_currency.flag + current_currency.code">
        {{ current_currency.flag }} {{ current_currency.code }}
      </button>
      <div class="dropdown-menu" :aria-labelledby="'currency-dropdown' + label_id">
        <a v-for="currency in currencies" class="dropdown-item" @click="setCurrency(currency.code)" v-html="currency.code + currency.flag" href="#"></a>
      </div>
    </div>
  </div>
</template>
 
<script>
export default {
  props: {
    prev_currency: {
      type: String,
      default: 'USD'
    },
    ui_style: {
      type: String,
      default: 'light'
    }
  },
  data: function () {
    return {
      label_id: Math.floor(1 + Math.random() * 999),
      currency: 'USD',
      current_currency: {
        flag: "<i class='far fa-globe mr-1 icon'></i>",
        code: "USD"
      },
      token: Laravel.csrfToken,
      currencies: [
        {
          flag: "<i class='far fa-globe mr-1 icon'></i>",
          code: "USD"
        },
        {
          flag: "🇬🇧",
          code: "GBP"
        },
        {
          flag: "🇦🇺",
          code: "AUD"
        },
        {
          flag: "🇲🇽",
          code: "MXN"
        },
        {
          flag: "🇮🇳",
          code: "INR"
        },
        {
          flag: "🇸🇬",
          code: "SGD"
        },
        {
          flag: "🇪🇺",
          code: "EUR"
        },
        {
          flag: "🇹🇷",
          code: "TRY"
        },
        {
          flag: "🇨🇦",
          code: "CAD"
        },
        {
          flag: "🇯🇵",
          code: "JPY"
        },
        {
          flag: "🇶🇦",
          code: "QAR"
        },
        {
          flag: "🇰🇷",
          code: "KRW"
        },
        {
          flag: "🇨🇭",
          code: "CHF"
        },
        {
          flag: "🇨🇳",
          code: "CNY"
        },
        {
          flag: "🇧🇷",
          code: "BRL"
        },
        {
          flag: "🇦🇪",
          code: "AED"
        },
        {
          flag: "🇸🇦",
          code: "SAR"
        },
        {
          flag: "🇸🇪",
          code: "SEK"
        },
        {
          flag: "🇵🇭",
          code: "PHP"
        },
        {
          flag: "🇲🇾",
          code: "MYR"
        },
        {
          flag: "🇿🇦",
          code: "ZAR"
        },
        {
          flag: "🇳🇿",
          code: "NZD"
        },
        {
          flag: "🇬🇪",
          code: "GEL"
        },
        {
          flag: "🇧🇴",
          code: "BOB"
        },
        {
          flag: "🇵🇰",
          code: "PKR"
        },
        {
          flag: "➕",
          code: "OTHER"
        }
      ]
    }
  },
  mounted() {
    if(this.prev_currency)
      this.currency = this.prev_currency;
    const result = this.currencies.find( ({ code }) => code === this.currency );
    this.current_currency = result;
  },
  methods: {
    setCurrency: function (currency) {
      if(currency == 'OTHER')
      {
        window.location.href = "mailto:hello@thecrystalcouncil.com?subject=International%20Currency%20Requet";
      }
      else
      {
        this.currency = currency;
        var _this = this;

        this.$http.post('/set-currency',{
          _token:_this.token,
          currency: _this.currency
        }).then(function(success) {
        window.location.reload(true);
        }, function(error) {
         
        });
      }
  }
}
};
</script> 